import React from "react";
import { Button, Modal } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

import EditEvent from "../../shared/EditEvent";
import LoadingSpinner from "../../shared/LoadingSpinner";

const EditEventModal = ({
  form,
  loading,
  onConfirm,
  onHide,
  onSplitConfirm,
  show,
  ...props
}) => (
  <Modal onHide={onHide} show={show}>
    <Modal.Header>
      <Modal.Title>
        <FontAwesome name="pencil" /> Edit Calendar Event
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {loading && <LoadingSpinner />}
      <EditEvent {...props} event={form} />
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onHide}>Close</Button>
      <Button bsStyle="primary" onClick={onSplitConfirm}>
        Split into Individual Events
      </Button>
      <Button bsStyle="primary" onClick={onConfirm}>
        Save
      </Button>
    </Modal.Footer>
  </Modal>
);

export default EditEventModal;
